/**
 * Utility function, creates AoPS.Contest if it doesn't exist already.
 */

AoPS.Utils.initKeyChain(AoPS, "Contests", "Models");

// Note: Extends from contests_common_models.js, which has the declaration for
//   many of the raw types.
AoPS.Contests.Models = (function (Models) {
	Models.Master = Models.GenericMaster.extend({
		initialize: function () {
			if (AoPS.isProduction !== undefined) {
				this.set("isProduction", AoPS.isProduction);
			}

			_.each(
				[
					"perms",
					"contest_events_cache",
					"contest_events",
					"contest_faqs",
					"events",
					"faqs",
					"is_portal_coach",
					"is_portal_student",
					"registration_forms",
					"ad",
				],
				_.bind(function (key) {
					if (AoPS.bootstrap_data[key] !== undefined) {
						this.set(key, AoPS.bootstrap_data[key]);
					}
				}, this)
			);
		},
		loadContestRegistration: function (contest_string, success, failure) {
			if (contest_string) {
				if (
					this.get("contests") &&
					this.get("contests").findWhere({contest_hash: contest_string})
				) {
					if (_.isFunction(success)) {
						success();
					}
				}
			} else if (this.get("hasLoadedContestLanding")) {
				if (_.isFunction(success)) {
					success();
				}
			}

			AoPS.Contests.Utils.ajax_runner.run(
				"load_contest_registration",
				{contest_string: contest_string || ""},
				_.bind(function (ok, data) {
					if (ok) {
						this.addOrUpdateContestFlavor(data.response.contest_flavors || []);
						this.addOrUpdateContest(data.response.contests || []);
						this.addOrUpdateContestWindow(data.response.contest_windows || []);
						this.addOrUpdateContestTeam(data.response.contest_teams || []);
						this.addOrUpdateContestTeamInvitation(
							data.response.contest_team_invitations || []
						);
						this.addOrUpdateContestRegistration(
							data.response.contest_registrations || []
						);
						this.addOrUpdateContestCms(data.response.contest_cms || []);

						if (!contest_string) {
							this.set("hasLoadedContestLanding", true);
						}

						if (_.isFunction(success)) {
							success();
						}

						if (!_.isUndefined(data.response.contest_alert)) {
							AoPS.Contests.Utils.CreateModalAlert(data.response.contest_alert);
						}
					} else {
						if (data.error_msg) {
							setTimeout(function () {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />").css("max-width", "480px").text(data.error_msg)
								);
							}, 100);
						}

						if (_.isFunction(failure)) {
							failure();
						}
					}
				}, this)
			);
		},
		getCmsTemplate: function (template_selector, vars) {
			return this.getCmsHelper(["landing_main"], template_selector, vars);
		},
		getCmsHelper: function (files, template_selector, vars) {
			var output = null;
			_.each(
				_.isArray(files) ? files : [files],
				_.bind(function (file) {
					if (_.isNull(output)) {
						var cms = this.getWhere("contest_cms", {file: file});
						if (cms) {
							output = cms.getHbOutput(template_selector, vars) || null;
						}
					}
				}, this)
			);
			return output;
		},
	});

	Models.Contest = Models.Contest.extend({
		fetch: function () {
			this.set(
				"flavor",
				this.get("master")
					.get("contest_flavors")
					.findWhere({flavor_hash: this.get("flavor_hash")})
			);
		},
		fieldsForMathcountsWeekRegistration: [
			{name: "school_name", caption: "School Name"},
			{name: "school_state", caption: "School State"},
			{name: "school_city", caption: "School City"},
			{name: "school_zip", caption: "School Zip"},
		],
		// List any dependents after their dependencies
		// or validation will not work!
		fieldsForUsemoRegistration: [
			{
				name: "full_name",
				caption: "Name",
				type: "text",
			},
			{
				name: "gender",
				caption: "Gender",
				type: "radio",
				dependent: "gender_other",
			},
			{
				name: "gender_other",
				caption: "Gender Note",
				type: "text",
				depends_on: "gender",
				dependency_value: "o",
			},
			{
				name: "grade",
				caption: "Grade",
				type: "radio",
				dependent: "grade_other",
			},
			{
				name: "grade_other",
				caption: "Grade Note",
				type: "text",
				depends_on: "grade",
				dependency_value: "o",
			},
		],
		fieldsForAoimePreregistration: [
			{
				name: "student_id",
				caption: "Student ID",
				type: "text",
			},
			{
				name: "school_ceeb",
				caption: "School CEEB",
				type: "text",
			},
		],
		fieldsForAoimeRegistration: [
			{
				name: "student_id",
				caption: "Student ID",
				type: "text",
				is_optional: 1,
			},
			{
				name: "school_ceeb",
				caption: "School CEEB",
				type: "text",
				is_optional: 1,
			},
			{
				name: "first_name",
				caption: "First Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "middle_initial",
				caption: "Middle Initial",
				type: "text",
				is_optional: 1,
			},
			{
				name: "last_name",
				caption: "Last Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "school_name",
				caption: "School Name",
				type: "text",
			},
			{
				name: "age",
				caption: "Age",
				type: "select",
				is_integer: 1,
			},
			{
				name: "grade",
				caption: "Grade",
				type: "select",
				is_integer: 1,
			},
			{
				name: "gender",
				caption: "Gender Note",
				caption_short: "Gender",
				type: "radio",
				dependent: "gender_other",
			},
			{
				name: "gender_other",
				caption: "Gender",
				type: "text",
				depends_on: "gender",
				dependency_value: "O",
				dependency_label: "Other",
			},
			{
				name: "student_email",
				caption: "Student Email",
				type: "text",
			},
			{
				name: "student_phone",
				caption: "Student Phone",
				type: "text",
			},
			{
				name: "home_address",
				caption: "Home Address",
				type: "text",
				is_optional: 1,
			},
			{
				name: "parent_email",
				caption: "Parent Email",
				type: "text",
				is_optional: 1,
			},
			{
				name: "parent_phone",
				caption: "Parent Phone",
				type: "text",
				is_optional: 1,
			},
			{
				name: "proctor_name",
				caption: "Proctor Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "proctor_email",
				caption: "Proctor Email",
				type: "text",
				is_optional: 1,
			},
			{
				name: "proctor_phone",
				caption: "Proctor Phone",
				type: "text",
				is_optional: 1,
			},
			{
				name: "will_usomo",
				caption: "If eligible, I will participate in the USO(J)MO",
				caption_short: "USO(J)MO Participation",
				type: "radio",
				is_integer: 1,
			},
		],
		fieldsForMaaOlympiadPreregistration: [
			{
				name: "student_id",
				caption: "Student ID",
				type: "text",
			},
			{
				name: "school_ceeb",
				caption: "School CEEB",
				type: "text",
			},
		],
		fieldsForMaaOlympiadRegistration: [
			{
				name: "registration_id",
				caption: "Registration ID",
				type: "text",
				is_optional: 1,
			},
			{
				name: "student_id",
				caption: "Student ID",
				type: "text",
				is_optional: 1,
			},
			{
				name: "school_ceeb",
				caption: "School CEEB",
				type: "text",
				is_optional: 1,
			},
			{
				name: "first_name",
				caption: "First Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "middle_initial",
				caption: "Middle Initial",
				type: "text",
				is_optional: 1,
			},
			{
				name: "last_name",
				caption: "Last Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "school_name",
				caption: "School Name",
				type: "text",
			},
			{
				name: "age",
				caption: "Age",
				type: "select",
				is_integer: 1,
			},
			{
				name: "grade",
				caption: "Grade",
				type: "select",
				is_integer: 1,
			},
			{
				name: "gender",
				caption: "Gender Note",
				caption_short: "Gender",
				type: "radio",
				dependent: "gender_other",
			},
			{
				name: "gender_other",
				caption: "Gender",
				type: "text",
				depends_on: "gender",
				dependency_value: "O",
				dependency_label: "Other",
			},
			{
				name: "student_email",
				caption: "Student Email",
				type: "text",
			},
			{
				name: "student_phone",
				caption: "Student Phone",
				type: "text",
			},
			{
				name: "home_address",
				caption: "Home Address",
				type: "text",
				is_optional: 1,
				concat_list: ["home_city", "home_state", "home_zip"],
			},
			{
				name: "home_city",
				caption: "City",
				type: "text",
				is_optional: 1,
				concats_to: "home_address",
			},
			{
				name: "home_state",
				caption: "State",
				type: "text",
				is_optional: 1,
				concats_to: "home_address",
			},
			{
				name: "home_zip",
				caption: "Zip Code",
				type: "text",
				is_optional: 1,
				concats_to: "home_address",
			},
			{
				name: "parent_email",
				caption: "Parent Email",
				type: "text",
				is_optional: 1,
			},
			{
				name: "parent_phone",
				caption: "Parent Phone",
				type: "text",
				is_optional: 1,
			},
			{
				name: "proctor_name",
				caption: "Proctor Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "proctor_email",
				caption: "Proctor Email",
				type: "text",
				is_optional: 1,
			},
			{
				name: "proctor_phone",
				caption: "Proctor Phone",
				type: "text",
				is_optional: 1,
			},
			{
				name: "is_us_citizen",
				caption: "I am a US citizen",
				caption_short: "US Citizen",
				type: "radio",
				is_integer: 1,
			},
			{
				name: "will_mop",
				caption:
					"If eligible, I will participate in the Mathematical Olympiad Program (MOP)",
				caption_short: "MOP Participation",
				type: "radio",
				is_integer: 1,
			},
		],
		fieldsForCmcOlympiadPreregistration: [
			{
				name: "unique_id",
				caption: "Student ID",
				type: "text",
			},
			{
				name: "registration_hash",
				caption: "Registration Code",
				type: "text",
			},
		],
		fieldsForCmcOlympiadRegistration: [
			{
				name: "unique_id",
				caption: "Student ID",
				type: "text",
				is_optional: 1,
			},
			{
				name: "registration_hash",
				caption: "Registration Code",
				type: "text",
				is_optional: 1,
			},
			{
				name: "country",
				caption: "Country",
				type: "text",
				is_optional: 1,
			},
			{
				name: "name",
				caption: "Name",
				type: "text",
			},
			{
				name: "school",
				caption: "School",
				type: "text",
			},
			{
				name: "age",
				caption: "Age",
				type: "select",
				is_integer: 1,
			},
			{
				name: "gender",
				caption: "Gender Note",
				caption_short: "Gender",
				type: "radio",
				dependent: "gender_other",
			},
			{
				name: "gender_other",
				caption: "Gender",
				type: "text",
				depends_on: "gender",
				dependency_value: "O",
				dependency_label: "Other",
			},
			{
				name: "email",
				caption: "Email Address",
				type: "text",
			},
		],
		fieldsForUSABORegistration: [
			{
				name: "student_id",
				caption: "USABO Student ID",
				type: "text",
			},
		],
		fieldsForMuAlphaThetaPreregistration: [
			{
				name: "student_id",
				caption: "Mu Alpha Theta Student ID",
				type: "text",
			},
		],
		fieldsForMuAlphaThetaRegistration: [
			{
				name: "student_id",
				caption: "Mu Alpha Theta Student ID",
				type: "text",
			},
			{
				name: "first_name",
				caption: "First Name",
				type: "text",
			},
			{
				name: "middle_name",
				caption: "Middle Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "last_name",
				caption: "Last Name",
				type: "text",
			},
			{
				name: "student_email",
				caption: "Student Email",
				type: "text",
			},
			{
				name: "parent_email",
				caption: "Parent Email",
				type: "text",
				is_optional: 1,
			},
			{
				name: "school_name",
				caption: "School Name",
				type: "text",
			},
			{
				name: "division",
				caption: "Division",
				type: "radio",
			},
			{
				name: "will_receive_emails",
				caption: "I consent to receive emails from AoPS",
				caption_short: "Consent to Receive AoPS Emails",
				type: "radio",
				is_integer: 1,
			},
		],
		fieldsForGaimElementaryPreregistration: [
			{
				name: "student_id",
				caption: "GAIM Elementary Student ID",
				type: "text",
			},
		],
		fieldsForGaimElementaryRegistration: [
			{
				name: "student_id",
				caption: "GAIM invitation id",
				type: "text",
			},
			{
				name: "first_name",
				caption: "First Name",
				type: "text",
			},
			{
				name: "middle_name",
				caption: "Middle Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "last_name",
				caption: "Last Name",
				type: "text",
			},
			{
				name: "student_email",
				caption: "Student Email",
				type: "text",
			},
			{
				name: "parent_email",
				caption: "Parent Email",
				type: "text",
				is_optional: 1,
			},
			{
				name: "school_name",
				caption: "School Name",
				type: "text",
			},
			{
				name: "grade",
				caption: "Grade",
				type: "select",
			},
			{
				name: "will_receive_emails",
				caption: "I consent to receive emails from AoPS",
				caption_short: "Consent to Receive AoPS Emails",
				type: "radio",
				is_integer: 1,
			},
		],
		fieldsForGaimMiddlePreregistration: [
			{
				name: "student_id",
				caption: "GAIM Middle Student ID",
				type: "text",
			},
		],
		fieldsForGaimMiddleRegistration: [
			{
				name: "student_id",
				caption: "GAIM invitation id",
				type: "text",
			},
			{
				name: "first_name",
				caption: "First Name",
				type: "text",
			},
			{
				name: "middle_name",
				caption: "Middle Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "last_name",
				caption: "Last Name",
				type: "text",
			},
			{
				name: "student_email",
				caption: "Student Email",
				type: "text",
			},
			{
				name: "parent_email",
				caption: "Parent Email",
				type: "text",
				is_optional: 1,
			},
			{
				name: "school_name",
				caption: "School Name",
				type: "text",
			},
			{
				name: "grade",
				caption: "Grade",
				type: "select",
			},
			{
				name: "will_receive_emails",
				caption: "I consent to receive emails from AoPS",
				caption_short: "Consent to Receive AoPS Emails",
				type: "radio",
				is_integer: 1,
			},
		],
		fieldsForF_maPreregistration: [
			{
				name: "registration_code",
				caption: "F=ma Registration Code",
				type: "text",
			},
		],
		fieldsForF_maRegistration: [
			{
				name: "first_name",
				caption: "First Name",
				type: "text",
			},
			{
				name: "middle_name",
				caption: "Middle Name",
				type: "text",
				is_optional: 1,
			},
			{
				name: "last_name",
				caption: "Last Name",
				type: "text",
			},
			{
				name: "location",
				caption: "Location of Exam",
				type: "radio",
				dependent: "location_other",
			},
			{
				name: "location_other",
				caption: "Location - Other (Please Specify)",
				depends_on: "location",
				dependency_value: "other",
			},
			{
				name: "physics_teacher",
				caption: "Name of Physics Teacher",
				type: "text",
			},
			{
				name: "current_school",
				caption: "Current School",
				type: "text",
			},
			{
				name: "school_city",
				caption: "School City",
				type: "text",
			},
			{
				name: "school_state",
				caption: "School State",
				type: "text",
			},
			{
				name: "grade",
				caption: "Grade",
				type: "radio",
			},
			{
				name: "birth_month",
				caption: "Birth Month",
				type: "select",
				is_integer: 1,
			},
			{
				name: "birth_year",
				caption: "Birth Year",
				type: "select",
				is_integer: 1,
			},
		],
		getProblemType: function (type, success = () => {}) {
			AoPS.Contests.Utils.ajax_runner.run(
				"get_problem_type",
				{type: type},
				_.bind(function (ok, data) {
					if (ok) {
						success(data.response.format_data);
					} else {
						if (data.error_msg) {
							setTimeout(function () {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />").css("max-width", "480px").text(data.error_msg)
								);
							}, 100);
						}
					}
				}, this)
			);
		},
		getCmsTemplate: function (template_selector, vars) {
			return this.get("master").getCmsHelper(
				_.uniq(
					["landing_contest_" + this.get("contest_cms_hash")]
						.concat(
							this.get("flavor")
								? [
										"landing_flavor_" +
											this.get("flavor").get("flavor_cms_hash"),
								  ]
								: []
						)
						.concat(["landing_flavor_default"])
				),
				template_selector,
				vars
			);
		},
		makeAjaxCall: function (action, ajax_data, success) {
			var loadingModal = AoPS.Contests.Utils.CreateModalInescapable();
			AoPS.Contests.Utils.ajax_runner.run(
				action,
				_.extend({contest_id: this.get("contest_id")}, ajax_data),
				_.bind(function (ok, data) {
					AoPS.Ui.Modal.removeModal(loadingModal);
					if (ok) {
						if (!_.isUndefined(data.response.contest_registrations)) {
							this.get("master").addOrUpdateContestRegistration(
								data.response.contest_registrations
							);
						}

						if (!_.isUndefined(data.response.contest_teams)) {
							this.get("master").addOrUpdateContestTeam(
								data.response.contest_teams
							);
						}

						if (!_.isUndefined(data.response.contest_team_invitations)) {
							this.get("master").addOrUpdateContestTeamInvitation(
								data.response.contest_team_invitations
							);
						}

						if (!_.isUndefined(data.response.invitation)) {
							this.set("current_invitation", data.response.invitation);
						}

						this.trigger("fetch");

						if (_.isFunction(success)) {
							success();
						}

						if (data.response.alert) {
							AoPS.Contests.Utils.CreateModalAlert(
								$("<div />").css("max-width", "480px").html(data.response.alert)
							);
						}
					} else if (data.error_code || data.error_msg) {
						AoPS.Contests.Utils.CreateModalAlert(
							$("<div />")
								.css("max-width", "480px")
								.text(data.error_msg || data.error_code)
						);
					}
				}, this)
			);
		},
		registerUser: function (register_data, success) {
			this.makeAjaxCall("register_user_for_contest", register_data, success);
		},
		createTeam: function (success) {
			this.makeAjaxCall("create_team", {}, success);
		},
		leaveTeam: function (success) {
			this.makeAjaxCall("leave_team", {}, success);
		},
		makeTeamLeader: function (user_id, success) {
			this.makeAjaxCall("make_team_leader", {user_id: user_id}, success);
		},
		removeTeamMember: function (user_id, success) {
			this.makeAjaxCall("remove_team_member", {user_id: user_id}, success);
		},
		sendTeamInvitation: function (user_id, success) {
			this.makeAjaxCall("send_team_invitation", {user_id: user_id}, success);
		},
		unsendTeamInvitation: function (user_id, success) {
			this.makeAjaxCall("unsend_team_invitation", {user_id: user_id}, success);
		},
		acceptTeamInvitation: function (contest_team_id, success) {
			this.makeAjaxCall(
				"accept_team_invitation",
				{contest_team_id: contest_team_id},
				success
			);
		},
		dismissTeamInvitation: function (contest_team_id, success) {
			this.makeAjaxCall(
				"dismiss_team_invitation",
				{contest_team_id: contest_team_id},
				success
			);
		},
		getInvitationData: function (invite_hash, success) {
			this.set("fetching_invite", true);
			this.makeAjaxCall(
				"get_invitation_data",
				{
					invite_hash: invite_hash,
				},
				_.bind(function () {
					this.set("fetching_invite", false);

					if (_.isFunction(success)) {
						success();
					}
				}, this)
			);
		},
		computeWindow: function () {
			if (this.get("contest_window")) {
				return this.get("contest_window");
			} else {
				var window =
					this.get("master")
						.get("contest_windows")
						.find(
							_.bind(function (item) {
								return (
									item.get("contest_id") === this.get("contest_id") &&
									item.get("can_display") &&
									!item.get("deleted_at")
								);
							}, this)
						) ||
					this.get("master")
						.get("contest_windows")
						.find(
							_.bind(function (item) {
								return (
									item.get("contest_id") === this.get("contest_id") &&
									!item.get("deleted_at")
								);
							}, this)
						);
				this.set("contest_window", window);
				return window;
			}
		},
		computeRegistration: function () {
			return this.get("master")
				.get("contest_registrations")
				.find(
					_.bind(function (item) {
						return (
							item.get("contest_id") === this.get("contest_id") &&
							!item.get("deleted_at")
						);
					}, this)
				);
		},
		computeTeam: function (registration) {
			registration = registration || this.computeRegistration();
			if (registration) {
				return this.get("master")
					.get("contest_teams")
					.find(
						_.bind(function (item) {
							return (
								item.get("contest_id") === registration.get("contest_id") &&
								item.get("contest_team_id") ===
									registration.get("contest_team_id") &&
								!item.get("deleted_at")
							);
						}, this)
					);
			}
		},
		computeTeamInvitations: function (registration) {
			registration = registration || this.computeRegistration();
			if (registration) {
				return this.get("master")
					.get("contest_team_invitations")
					.filter(
						_.bind(function (item) {
							return (
								item.get("contest_id") === registration.get("contest_id") &&
								item.get("contest_team_id") !==
									registration.get("contest_team_id") &&
								item.get("user_id") === registration.get("user_id") &&
								!item.get("deleted_at")
							);
						}, this)
					);
			} else {
				return [];
			}
		},
		export: function () {
			console.log(AoPS.session);
			var window = this.computeWindow();
			var registration = this.computeRegistration();
			var team = this.computeTeam();
			var team_invitations = this.computeTeamInvitations();
			var flavor = this.get("flavor");
			var is_logged_in = AoPS.session.logged_in;
			var local_tz = moment.tz.guess();

			var output = {
				privacy_statement: this.get("privacy_statement"),
				contest_name: this.get("contest_name"),
				contest_short_name: this.get("contest_short_name"),
				contest_logo: this.get("contest_logo"),
				secondary_logo: this.get("secondary_logo"),
				alternate_logo: this.get("alternate_logo"),
				contest_url: "/contests/" + this.get("contest_hash"),
				contest_register_url:
					"/contests/" + this.get("contest_hash") + "/register",
				contest_start_url: "/contests/" + this.get("contest_hash") + "/start",
				contest_individual_url:
					"/contests/" + this.get("contest_hash") + "/individual",
				contest_practice_url:
					"/contests/" + this.get("contest_hash") + "/practice",
				contest_team_url: "/contests/" + this.get("contest_hash") + "/team",
				contest_videos_url: "/contests/" + this.get("contest_hash") + "/videos",
				contest_details_url:
					"/contests/" + this.get("contest_hash") + "/details",
				contest_leaderboards_url:
					"/contests/" + this.get("contest_hash") + "/leaderboards",
				contest_review_url: "/contests/" + this.get("contest_hash") + "/review",
				contest_data: this.get("data"),
				is_logged_in,
				registration_cap: {
					is_capped: this.get("has_registration_cap"),
					allow_new_registration: !this.get("registration_maxed"),
					allow_change_to_official: !this.get("registration_maxed"),
					allow_accept_invite:
						!this.get("registration_maxed") ||
						this.get("include_invites_in_cap"),
					remaining_spots: this.get("remaining_spots"),
				},
				local_time_zone_name: moment().tz(local_tz).format("z"),
				is_portal_coach: this.get("master").get("is_portal_coach"),
				is_portal_student: this.get("master").get("is_portal_student"),
				registration: {
					contest_registration_id: registration
						? registration.get("contest_registration_id")
						: 0,
					is_official: registration ? registration.get("is_official") : "",
					is_public: registration ? registration.get("is_public") : "",
					is_coppa: registration ? registration.get("is_coppa") : false,
					is_complete: registration ? registration.get("is_complete") : false,
					coppa_cleared: registration
						? registration.get("coppa_cleared")
						: false,
					data: registration ? registration.get("data") : {},
					locked_at: registration ? registration.get("locked_at") : null,
					individual_contest_started_at: registration
						? registration.get("individual_contest_started_at")
						: null,
					individual_contest_ended_at: registration
						? registration.get("individual_contest_ended_at")
						: null,
					practice_contest_started_at: registration
						? registration.get("practice_contest_started_at")
						: null,
					practice_contest_ended_at: registration
						? registration.get("practice_contest_ended_at")
						: null,
					team_contest_started_at: registration
						? registration.get("team_contest_started_at")
						: null,
					team_contest_ended_at: registration
						? registration.get("team_contest_ended_at")
						: null,
					individual_contest_score: registration
						? registration.get("individual_contest_score")
						: null,
					practice_contest_score: registration
						? registration.get("practice_contest_score")
						: null,
					team_contest_score: registration
						? registration.get("team_contest_score")
						: null,
				},
				registration_forms: [],
			};

			if (registration) {
				var has_finished_individual_contest =
					registration.get("individual_contest_ended_at") ||
					(registration.get("individual_contest_to_end_at") &&
						moment().diff(
							moment.tz(
								registration.get("individual_contest_to_end_at"),
								"America/New_York"
							)
						) > 0);
				var has_finished_team_contest =
					registration.get("team_contest_ended_at") ||
					(registration.get("team_contest_to_end_at") &&
						moment().diff(
							moment.tz(
								registration.get("team_contest_to_end_at"),
								"America/New_York"
							)
						) > 0);

				output = _.extend(output, {
					has_finished_individual_contest: has_finished_individual_contest
						? 1
						: 0,
					has_finished_team_contest: has_finished_team_contest ? 1 : 0,
				});
			}

			if (flavor) {
				output = _.extend(output, {
					contest_flavor_team_size:
						flavor.get("has_team") && flavor.get("max_team_size") > 1
							? flavor.get("max_team_size")
							: 0,
					contest_flavor_crumb_name: flavor.get("flavor_crumb_name"),
					contest_flavor_name: flavor.get("flavor_public_name"),
				});

				if (flavor.get("has_team") && flavor.get("max_team_size") > 1) {
					output = _.extend(output, {
						max_team_size: flavor.get("max_team_size"),
						team: {
							contest_team_id: team ? team.get("contest_team_id") : 0,
							team_name: team ? team.get("team_name") : "",
							team_leader_is_self:
								team && team.get("team_leader_user_id") === AoPS.session.user_id
									? 1
									: 0,
							team_leader_user_id: team ? team.get("team_leader_user_id") : 0,
							team_leader_username: team
								? team.get("team_leader_username")
								: "",
							is_official: team && team.get("is_official") ? 1 : 0,
							num_members: team ? team.get("num_members") : 0,
							num_members_is_plural:
								team && team.get("num_members") > 1 ? 1 : 0,
							num_remaining: team
								? Math.max(
										0,
										flavor.get("max_team_size") - team.get("num_members")
								  )
								: 0,
							num_invites_remaining: team
								? Math.max(
										0,
										flavor.get("max_team_size") -
											team.get("num_members") -
											(team.get("data").invites || []).length
								  )
								: 0,
							data: team ? team.get("data") : {},
							locked_at: registration ? registration.get("locked_at") : null,
						},
						team_invitations: _.map(
							team_invitations,
							_.bind(function (invitation) {
								var members = _.pluck(
									invitation.get("team_data").members,
									"username"
								);
								var member_list = "";
								for (var i = 0; i < members.length; i++) {
									member_list += members[i];
									if (i < members.length - 2) {
										member_list += ", ";
									} else if (i < members.length - 1) {
										member_list += (i > 0 ? "," : "") + " and ";
									}
								}

								return {
									contest_team_invitation_id: invitation.get(
										"contest_team_invitation_id"
									),
									contest_team_id: invitation.get("contest_team_id"),
									team_name: invitation.get("team_name"),
									team_leader_user_id: invitation.get("team_leader_user_id"),
									team_leader_username: invitation.get("team_leader_username"),
									team_is_official: invitation.get("team_is_official"),
									team_data: invitation.get("team_data"),
									member_list: member_list,
								};
							}, this)
						),
						num_team_invitations: team_invitations.length,
						num_team_invitations_is_plural: team_invitations.length > 1 ? 1 : 0,
						num_sent_team_invitations: team
							? (team.get("data").invites || []).length
							: 0,
						num_sent_team_invitations_is_plural:
							team && (team.get("data").invites || []).length > 1 ? 1 : 0,
					});
				}

				if (flavor.get("flavor_hash") === "maa_olympiad") {
					output.is_junior_olympiad = this.get("contest_hash") === "usojmo";
				}
			}

			if (window) {
				output = _.extend(output, {
					is_admin_only:
						window.get("contest_preview_can_access") &&
						!window.get("contest_window_can_access")
							? 1
							: 0,
					practice_can_access:
						is_logged_in && window.get("practice_test_can_access") ? 1 : 0,
					contest_can_access:
						is_logged_in && window.get("contest_can_access") ? 1 : 0,
					contest_anyone_can_access: window.get("contest_can_access") ? 1 : 0,
					is_before_contest: !window.get(
						"official_individual_contest_has_started"
					),
					is_during_contest: window.get(
						"official_individual_contest_is_current"
					),
					is_after_contest: window.get("official_individual_contest_has_ended"),
					official_contest_anyone_can_access:
						window.get("official_individual_contest_can_access") ||
						window.get("official_team_contest_can_access")
							? 1
							: 0,
					individual_contest_can_access:
						is_logged_in && window.get("individual_contest_can_access") ? 1 : 0,
					individual_contest_anyone_can_access: window.get(
						"individual_contest_can_access"
					)
						? 1
						: 0,
					team_contest_can_access:
						is_logged_in && window.get("team_contest_can_access") ? 1 : 0,
					team_contest_anyone_can_access: window.get("team_contest_can_access")
						? 1
						: 0,
					official_registration_has_started: window.get(
						"official_registration_has_started"
					)
						? 1
						: 0,
					unofficial_registration_has_started: window.get(
						"unofficial_registration_has_started"
					)
						? 1
						: 0,
					registration_has_started:
						window.get("official_registration_has_started") ||
						window.get("unofficial_registration_has_started")
							? 1
							: 0,
					registration_can_access: window.get("registration_can_access")
						? 1
						: 0,
					official_registration_can_access: window.get(
						"official_registration_can_access"
					)
						? 1
						: 0,
					unofficial_registration_can_access: window.get(
						"unofficial_registration_can_access"
					)
						? 1
						: 0,
					registration_can_view:
						is_logged_in &&
						(window.get("registration_can_access") ||
							(registration && registration.get("contest_registration_id")))
							? 1
							: 0,
					registration_can_edit:
						is_logged_in &&
						window.get("registration_can_access") &&
						(!registration || !registration.get("locked_at"))
							? 1
							: 0,
					team_registration_can_edit:
						is_logged_in &&
						window.get("registration_can_access") &&
						(!team || !team.get("locked_at"))
							? 1
							: 0,
				});

				_.each(
					_.reduce(
						window.getIntervalNames(),
						_.bind(function (carry, item) {
							return carry.concat([item + "_start", item + "_end"]);
						}, this),
						window.getStatusNames()
					),
					_.bind(function (col) {
						var prefixes = [
							{prefix: "", tz: "America/New_York"},
							{prefix: "utc_", tz: "ETC/UTC"},
							{prefix: "local_", tz: local_tz},
						];

						var suffixes = [
							{suffix: "", format: "MMMM D"},
							{suffix: "_with_ending", format: "MMMM Do"},
							{suffix: "_month", format: "MMMM"},
							{suffix: "_day", format: "D"},
							{suffix: "_day_with_ending", format: "Do"},
							{suffix: "_year", format: "YYYY"},
							{suffix: "_dow", format: "dddd"},
							{suffix: "_time", format: "h:mm a"},
							{suffix: "_time_no_am_pm", format: "H:mm"},
						];

						var dt = window.get(col + "_at")
							? moment.tz(window.get(col + "_at"), "America/New_York")
							: null;

						_.each(
							prefixes,
							_.bind(function (pre) {
								dt = dt ? dt.tz(pre.tz) : null;
								_.each(
									suffixes,
									_.bind(function (suf) {
										output[pre.prefix + col + suf.suffix] = dt
											? dt.format(suf.format)
											: null;
									}, this)
								);
							}, this)
						);

						output[col + "_unix_time"] = dt ? dt.unix() * 1000 : null;
					}, this)
				);

				_.each(
					window.getIntervalNames(),
					_.bind(function (item) {
						output[item + "_has_started"] = window.get(item + "_has_started");
						output[item + "_has_ended"] = window.get(item + "_has_ended");
					}, this)
				);

				if (flavor.get("flavor_hash") === "usemo") {
					output = _.extend(output, {
						waiting_for_results:
							window.get("official_individual_contest_has_ended") &&
							!window.get("show_leaderboard_currently"),
						results_released:
							window.get("official_individual_contest_has_ended") &&
							window.get("show_leaderboard_currently"),
					});
				}
				output.leaderboards_can_access =
					moment().valueOf() - output.show_leaderboard_unix_time > 0 ? 1 : 0;

				// Can't access old leaderboards - we've removed the display names.
				if (output.contest_window_start_unix_time < AoPS.bd.pii_removed_at) {
					output.leaderboards_can_access = false;
				}

				if (output.show_review_unix_time) {
					output.review_can_access =
						moment().valueOf() - output.show_review_unix_time > 0 ? 1 : 0;
				}
			}

			// process registration forms
			var registration_forms = this.get("master").get("registration_forms");
			for (var user_type of Object.keys(registration_forms)) {
				// output.registration_forms[user_type] = [];
				output.registration_forms[user_type] =
					AoPS.Contests.Utils.processRegistrationForm(
						registration_forms[user_type],
						output.registration.data
					);
			}

			return output;
		},
	});

	return Models;
})(AoPS.Contests.Models);
